// build: 2026-04-22-asset-fix
import { createRouter as createTanStackRouter } from "@tanstack/react-router"
import { DefaultCatchBoundary } from "./components/DefaultCatchBoundary"
import { NotFound } from "./components/not-found"
import type { RootContext } from "./contexts/root-context/RootContext"
import { routeTree } from "./routeTree.gen"

export function createRouter(context: RootContext) {
  const router = createTanStackRouter({
    routeTree,
    context,
    defaultPreload: "intent",
    defaultErrorComponent: DefaultCatchBoundary,
    defaultNotFoundComponent: () => <NotFound />,
    scrollRestoration: true,
  })

  return router
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createRouter>
  }
}
